// Actions for Editing Behavior

import TYPES from "./types";
import { axiosInstance, tokenConfig } from "../../../axiosInstance";
import { returnErrors, clearErrors } from "../../../actions/errorActions";
import API from "../API";

const {
  EDIT_ARTICLE_LOADING,
  EDIT_ARTICLE_SUCCESS,
  EDIT_ARTICLE_FAIL,
} = TYPES;

export const editArticle = ({ title, cat_id, sub_cat_id, keywords, description, image, id }) => {
  return async function(dispatch, getState){
      dispatch(clearErrors());
      dispatch({
          type: EDIT_ARTICLE_LOADING
      });
      const body = {title, cat_id, sub_cat_id, keywords, description, image, id}
      try {
          let response = await axiosInstance.post(
            API.ARTICLES, 
            body, 
            tokenConfig(getState)
          );
          if(response.status !== 200){
              dispatch({
                  type: EDIT_ARTICLE_FAIL,
              });
              throw Error({
                  response: {
                      data: "Other Errors",
                      status: "Other Errors"
                  },
              })
          }else{
              dispatch({
                  type: EDIT_ARTICLE_SUCCESS,
                  payload: response.data
              })
          }
      } catch (error) {
          if (error.response && error.response.data) {
            dispatch(returnErrors(error.response.data, error.response.status, 'EDIT_ARTICLE_FAIL'));
            dispatch ({ 
                type: EDIT_ARTICLE_FAIL 
            });
          }else{
            let errorJson = JSON.stringify(error);
            let errorParsed = JSON.parse(errorJson);
            return (
                dispatch(returnErrors(errorParsed.message, "Network Error", 'EDIT_ARTICLE_FAIL')),
                dispatch ({ 
                    type: EDIT_ARTICLE_FAIL 
                })
            )
          }
      }
  }
};

const exportedObject = {
  editArticle
};

export default exportedObject;
